import { useState } from "react";
import {
  UsersCheckSellerIdPostRequest,
  RequestCheckSellerIdRequest,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiCheckSellerId = () => {
  const [result, setResult] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const checkSellerId = async (req: RequestCheckSellerIdRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersCheckSellerIdPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersCheckSellerIdPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("セラーIDの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { checkSellerId, result, error, isLoading };
};
